export enum DashboardItem{
	FOLDER = 'FOLDER',
	ATTACHMENT = 'ATTACHMENT',
	TREATMENT_HOLDER = 'TREATMENT_HOLDER',
	TREATMENT_RESPONSIBLE = 'TREATMENT_RESPONSIBLE',
	TREATMENT_PROJECT = 'TREATMENT_PROJECT',
	TREATMENT_SUB_RESPONSIBLE = 'TREATMENT_SUB_RESPONSIBLE',
	GLOBAL_MEASURE_CHECK = 'GLOBAL_MEASURE_CHECK',
	DPIA = 'DPIA',
	APP_ASSESSMENT = 'APP_ASSESSMENT',
	AI_ASSESSMENT = 'AI_ASSESSMENT',
	COVID_ASSESSMENT = 'COVID_ASSESSMENT',
	APPLICATIONS = 'APPLICATIONS',
	INTERNAL_LE = 'INTERNAL_LE',
}
